import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


// components
import HtmlPart from '../../parts/HtmlPart';
import GhostButton from '../../parts/GhostButton';
import TextCTA from '../../layout/buttons/TextCTA';
import CardTitlePart from '../../parts/CardTitlePart';
import OverlayLoader from '../../parts/OverlayLoader';
import SuccessConfirmationOverlay from '../../parts/SuccessConfirmationOverlay';
import FailureOverlay from '../../parts/FailureOverlay';

import Basket from '../../parts/Basket/';
import PopOverToolTip from '../../layout/PopOverToolTip';

// actions
import { confirmOrder } from '../../actions/orders';

import { gtmCardEvent } from '../../services/gtmService';

class _ConfirmOrderCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loadState: 'none'
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
  }

  handleConfirm() {
    gtmCardEvent('order-confirmation', 'click-confirm-order')();
    this.setState({
      loadState: 'loading'
    });
    this.props.confirmOrder(this.props.id, this.props.orderRef, this.props.orderIdx)
      .then(() => {
        this.setState({ loadState: 'success' });
      })
      .catch(() => {
        this.setState({ loadState: 'failure' });
        setTimeout(() => this.setState({ loadState: 'none' }), 3000);
      });
  }

  togglePopup() {
    gtmCardEvent('order-confirmation', 'click-change-order')();
    this.setState({
      showPopup: !this.state.showPopup
    });
  }

  render() {
    const { total, items, balance, deposit, title, bodyText, confirmButton,
      changeOrderButtonText, changeOrderPopup, orderRef, orderNo, orderIdx } = this.props;
    const { showPopup } = this.state;
    // add basket item values to total

    return (
      <div>

        <CardTitlePart title={title} />

        <div className="basket-wrap u-padding-small u-pale-grey-bg">

          <Basket
            items={items}
            total={total}
            deposit={deposit}
            balance={balance}
            orderIdx={orderIdx}
          />

          <div className="u-padding-x-tiny u-padding-top-small u-text-center c-event-feed__card__extra-info">
            <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
          </div>

        </div>

        <div className="c-event-feed__card__splitter u-padding-x-small">

          <OverlayLoader active={this.state.loadState === 'loading'} scale={0.5} background="rgb(255, 255, 255, 0.8)" />

          {this.state.loadState === 'success' ? <SuccessConfirmationOverlay /> : null}
          {this.state.loadState === 'failure' ? <FailureOverlay /> : null}


          <PopOverToolTip
            show={showPopup}
            content={changeOrderPopup}
          />
          
          <div className="u-flex u-flex-justify-space-between u-w-100">
            <TextCTA
              disabled={this.state.loadState !== 'none'}
              text={changeOrderButtonText}
              onBtnClick={this.togglePopup}
              extraClass={''}
              size="50"
            />

            <GhostButton
              disabled={this.state.loadState !== 'none'}
              text={confirmButton}
              onBtnClick={this.handleConfirm}
              size="50"
              extraClass={''}
            />
          </div>

        </div>
        <div className="u-padding-small">
          <HtmlPart htmlString={bodyText} />
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => bindActionCreators({ confirmOrder }, dispatch);

const ConfirmOrderCard = connect(null, mapDispatchToProps)(_ConfirmOrderCard);

export default ConfirmOrderCard;



// WEBPACK FOOTER //
// ./src/cards/templates/ConfirmOrderCard.js